import { ServiceApi } from "../serviceApi"
import { EventsManager } from "./eventsManager";
import { IUrlObject } from "../resources/url.resource";
import { Event } from "./Event";

export class EventsServiceApi extends ServiceApi {
  constructor (private event: Event, serviceUrlObj: IUrlObject, activeAuth?: Object) {
    super(serviceUrlObj, activeAuth);
  }

  newHttpResource () {
    return this.event.getCurrentPersonId().then(personKey => {
      this.setPersonKey(personKey);
      return super.newHttpResource();
    })
  }
}